export default __webpack_public_path__ + "static/media/forgetoken.ee7fc645.png";